import { fetchRefusals } from '../../api';

const state = {
  list: [],
};

const getters = {
  list: ({ list }) => list,
};

const actions = {
  loadRefusals({ commit }) {
    return fetchRefusals()
      .then((res) => {
        commit('setRefusals', res || []);
        return res;
      });
  },
};

const mutations = {
  // eslint-disable-next-line
  setRefusals(state, payload) {
    // eslint-disable-next-line
    state.list = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
